import {Action} from '@ngrx/store';

export class LoginSuccessAction implements Action {
  public static readonly type = 'LoginSuccessAction';

  public type = LoginSuccessAction.type;
}
